export const LISTA_MENU_INICIAL = [
    {
        id: 1,
        descripcion: 'Resumen ADN',
        url: '/resumenADN',
        completado: false,
        paginaActual: true
    },
    {
        id: 2,
        descripcion: 'Información',
        url: null,
        completado: false,
        paginaActual: false,
        listaSubmenu: [
            {
                id: 1,
                descripcion: 'Protección de datos',
                url: '/informacion/lpdp',
                completado: false,
                idPadre: 2,
                paginaActual: false
            },
            {
                id: 2,
                descripcion: 'Beneficiarios',
                url: '/informacion/beneficiarios',
                completado: false,
                idPadre: 2,
                paginaActual: false
            },
            {
                id: 3,
                descripcion: 'Declaración de salud',
                url: '/informacion/declaracionSalud',
                completado: false,
                idPadre: 2,
                paginaActual: false
            },
            {
                id: 4,
                descripcion: 'Asegurado',
                url: '/informacion/asegurado',
                completado: false,
                idPadre: 2,
                paginaActual: false
            },
            {
                id: 5,
                descripcion: 'Contratante',
                url: '/informacion/contratante',
                completado: false,
                idPadre: 2,
                paginaActual: false
            },
            {
                id: 6,
                descripcion: 'Productos',
                url: '/informacion/productos',
                completado: false,
                idPadre: 2,
                paginaActual: false
            }
        ]
    }, {
        id: 3,
        descripcion: 'Requisitos',
        url: '/requisitos',
        completado: false,
        paginaActual: false
    }, {
        id: 4,
        descripcion: 'Firma',
        url: '/firma',
        completado: false,
        paginaActual: false
    }, {
        id: 5,
        descripcion: 'Primer Pago',
        url: '/primerPago',
        completado: false,
        paginaActual: false
    }
]

export const PREGUNTAS_INICIALES = [
    {
        codigo: 1,
        grupo: 1,
        tipoDetalle: 1
    }, {
        codigo: 42,
        grupo: 1,
        tipoDetalle: 1
    },
    {
        codigo: 43,
        grupo: 1,
        tipoDetalle: 2
    },
    {
        codigo: 2,
        grupo: 1,
        tipoDetalle: 2
    },
    {
        codigo: 44,
        grupo: 1,
        tipoDetalle: 3
    },
    {
        codigo: 3,
        grupo: 1,
        tipoDetalle: 3
    },
    {
        codigo: 14,
        grupo: 2,
        tipoDetalle: null
    },
    {
        codigo: 52,
        grupo: 2,
        tipoDetalle: null
    },
    {
        codigo: 115,
        grupo: 1,
        tipoDetalle: 5
    }
]

export const PREGUNTAS_INICIALES_ADICIONAL = [
    {
        codigo: 1,
        grupo: 1,
        tipoDetalle: 1
    },
    {
        codigo: 2,
        grupo: 1,
        tipoDetalle: 2
    },
    {
        codigo: 14,
        grupo: 2,
        tipoDetalle: null
    }
]

export const SUBPREGUNTAS_INICIALES = [
    {
        codigo: 57,
        grupo: 1,
        tipoDetalle: 1
    }, {
        codigo: 59,
        grupo: 1,
        tipoDetalle: 1
    },
    {
        codigo: 58,
        grupo: 1,
        tipoDetalle: 2
    },
    {
        codigo: 60,
        grupo: 1,
        tipoDetalle: 2
    }
]

export const PREGUNTAS_INICIALES_AUX = [
    {
        codigo: 1,
        grupo: 1,
        tipoDetalle: 1
    }, {
        codigo: 42,
        grupo: 1,
        tipoDetalle: 1
    },
    {
        codigo: 43,
        grupo: 1,
        tipoDetalle: 2
    },
    {
        codigo: 2,
        grupo: 1,
        tipoDetalle: 2
    },
    {
        codigo: 44,
        grupo: 1,
        tipoDetalle: 3
    },
    {
        codigo: 14,
        grupo: 2,
        tipoDetalle: null
    },
    {
        codigo: 52,
        grupo: 2,
        tipoDetalle: null
    },
    {
        codigo: 115,
        grupo: 1,
        tipoDetalle: 5
    }
]

export const PREGUNTAS_INICIALES_PROD = [
    {
        codigo: 10,
        grupo: 1,
        tipoDetalle: 2
    },
    {
        codigo: 11,
        grupo: 1,
        tipoDetalle: 2
    },
    {
        codigo: 14,
        grupo: 1,
        tipoDetalle: null
    },
    {
        codigo: 3,
        grupo: 1,
        tipoDetalle: 3
    },
    {
        codigo: 52,
        grupo: 1,
        tipoDetalle: null
    }
]

export const PREGUNTAS_INICIALES_PROD_AUX = [
    {
        codigo: 10,
        grupo: 1,
        tipoDetalle: 2
    },
    {
        codigo: 11,
        grupo: 1,
        tipoDetalle: 2
    },
    {
        codigo: 14,
        grupo: 1,
        tipoDetalle: null
    },
    {
        codigo: 52,
        grupo: 1,
        tipoDetalle: null
    }
]

export const ADN_COL_PROYECCION = {
    objColumnas_4: {//Tipo Producto: Accidentes Personales
        'anio': 'Año',
        'edad': 'Edad',
        'primaAcumulada': 'Prima AC.',
        'porcentajeRetiro': 'Retiro(%)',
        'montoRetiro': 'Retiro'
    },
    objColumnas_2: {//Tipo Producto: Fondo Universitario
        'anio': 'Año',
        'edad': 'Edad',
        'primaAnual': 'Prima A.',
        'primaAcumulada': 'Prima AC.',
        'saldoCuentaIndividual': 'Saldo C.I',
        'saldoCuentaExcedente': 'Saldo C.E',
        'interesesExcedentesAcumulados': 'I.A',
        'valorRescate': 'Valor R'
    },
    objColumnas_5: {//Tipo Producto: Vida Inversión
        'anio': 'Año',
        'edad': 'Edad',
        'primaAnual': 'Prima A.',
        'saldoCuentaIndividual': 'Saldo C.I',
        'saldoCuentaExcedente': 'Saldo C.E',
        'saldoCuentaConsolidada': 'Saldo C.C',
        'valorRescate': 'Valor R',
        'sumaAsegurada': 'Suma A'
    },
    objColumnas_3: {//Tipo Producto: Vida Temporal
        'anio': 'Año',
        'edad': 'Edad',
        'primaAcumulada': 'Prima AC.',
        'porcentajeRetiro': 'Retiro(%)',
        'montoRetiro': 'Retiro'
    },
    objColumnas_default: {//Otros Producto
        'anio': 'Año',
        'edad': 'Edad',
        'interesesExcedentesAcumulados': 'I.A',
        'primaAcumulada': 'Prima AC.',
        'primaAnual': 'Prima A.',
        'saldoCuentaConsolidada': 'Saldo C.C',
        'saldoCuentaExcedente': 'Saldo C.E',
        'saldoCuentaIndividual': 'Saldo C.I',
        'sumaAsegurada': 'Suma A',
        'valorRescate': 'Valor R'
    }
}

export const CODIGOS_COBERTURAS_INVALIDEZ = [9, 52, 53, 80, 104, 105]
export const CODIGOS_COBERTURAS_EDM = [4, 5, 90, 91, 121, 279, 280]
